import React, { useEffect, useRef, useState } from "react";
import { Button, message, Tag } from "antd";
import { revealBankAccountCredentials } from "../../services/bankAccountApi";

export default function AccountDetails({ account, currentUser }) {
  const [visible, setVisible] = useState({});
  const [busy, setBusy] = useState("");
  const sequence = useRef(0);
  const currentAccountId = useRef(account?.id);
  currentAccountId.current = account?.id;
  useEffect(() => { setVisible({}); setBusy(""); return () => { sequence.current += 1; }; }, [account?.id]);
  if (!account) return null;
  const canReveal = ["SUPER_ADMIN", "ADMIN"].includes(currentUser?.role);
  async function toggle(field) {
    if (visible[field] !== undefined) { setVisible(v => { const next = { ...v }; delete next[field]; return next; }); return; }
    const request = ++sequence.current;
    const requestedAccountId = account.id;
    setBusy(field);
    try {
      const secrets = await revealBankAccountCredentials(account.id);
      if (sequence.current === request && currentAccountId.current === requestedAccountId)
        setVisible(v => ({ ...v, [field]: secrets[field] || "—" }));
    } catch (e) { if (sequence.current === request) message.error(e.message || "Không thể xem mật khẩu"); }
    finally { if (sequence.current === request) setBusy(""); }
  }
  const fact = (label, value) => <div><span>{label}</span><strong>{value || "—"}</strong></div>;
  const password = (label, field, exists) => <div><span>{label}</span><div className="credential-value">
    <strong>{visible[field] !== undefined ? visible[field] : exists ? "••••••••" : "Chưa cập nhật"}</strong>
    {canReveal && exists && <Button type="link" loading={busy === field} disabled={Boolean(busy)} onClick={() => toggle(field)} aria-label={`${visible[field] !== undefined ? "Ẩn" : "Xem"} ${label}`}>{visible[field] !== undefined ? "Ẩn" : "Xem"}</Button>}
  </div></div>;
  return <>
    <div className="form-section-heading">Thông tin tài khoản</div>
    <div className="detail-grid">
      {fact("Số tài khoản", account.accountNumber || account.accountNumberMasked)}
      {fact("Tên tài khoản", account.accountHolder)}
      {fact("Ngân hàng · Chi nhánh", [account.bankName, account.branch].filter(Boolean).join(" · "))}
      {fact("Trạng thái", <Tag color={account.active ? "green" : "default"}>{account.active ? "Đang dùng" : "Ngừng dùng"}</Tag>)}
    </div>
    <div className="form-section-heading">Thông tin đăng nhập</div>
    <div className="detail-grid">
      {fact("Tên đăng nhập cũ", account.oldUsername)}{password("Pass cũ", "oldPassword", account.hasOldPassword)}
      {fact("Tên đăng nhập mới", account.newUsername)}{password("Pass mới", "newPassword", account.hasNewPassword)}
    </div>
    <p className="field-help">Chỉ Super Admin và Admin được xem mật khẩu.</p>
  </>;
}
